import React from 'react'
import Roles from '../components/roles/Roles'
import { hasPermission } from '../components/auth/login/Login';

const RolesListing = () => {

    const canSetRolesAndPermissions = hasPermission("Roles and Permissions", "Roles", "read");

    if (!canSetRolesAndPermissions) {
        window.location.href = '/no-permission';
    }

    return (
        <div className='outletConainer'><Roles /></div>
    )
}

export default RolesListing
